// eslint-disable-next-line max-classes-per-file
import type {
  TicketAvailableDataPackage,
  TicketAvailableDataPackageItineraryDetail,
} from "./getTickerAvailableV3PackageInterface/getTickerAvailableV3PackageInterface";
import {
  GetTicketAvailableDataPackage,
  GetTicketAvailableDataPackageItineraryDetail,
} from "./getTickerAvailableV3PackageInterface/getTickerAvailableV3PackageInterface";

export interface TicketAvailableDataCalendarSession {
  id: string;
  name: string;
}

export class GetTicketAvailableDataCalendarSession {
  id: string;

  name: string;

  constructor(response: TicketAvailableDataCalendarSession) {
    this.id = response?.id ?? "";
    this.name = response?.name ?? "";
  }
}
export interface TicketAvailableDataCalendar {
  date: string;
  price: number;
  round: string[];
  sessions: TicketAvailableDataCalendarSession[];
}

export class GetTicketAvailableDataCalendar {
  date: string;

  price: number;

  round: string[];

  sessions: TicketAvailableDataCalendarSession[];

  constructor(response: TicketAvailableDataCalendar) {
    this.date = response?.date ?? "";
    this.price = response?.price ?? 0;
    this.round = response?.round ?? [];
    this.sessions = (response.sessions || []).map(
      (res) => new GetTicketAvailableDataCalendarSession(res),
    );
  }
}

export interface TicketAvailableDataCountry {
  name: string;
  slug: string;
  isoCode2a: string;
}

export class GetTicketAvailableDataCountry {
  name: string;

  slug: string;

  isoCode2a: string;

  constructor(response: GetTicketAvailableDataCountry) {
    this.name = response?.name ?? "";
    this.slug = response?.slug ?? "";
    this.isoCode2a = response?.isoCode2a ?? "";
  }
}

export interface TicketAvailableDataKlubCategory {
  name: string;
  slug: string;
}

export class GetTicketAvailableDataKlubCategory {
  name: string;

  slug: string;

  constructor(response: GetTicketAvailableDataKlubCategory) {
    this.name = response?.name ?? "";
    this.slug = response?.slug ?? "";
  }
}

export interface TicketAvailableData {
  name: string;
  isSEO: boolean;
  isJoin: boolean;
  bestSeller: boolean;
  topRating: boolean;
  rounds: string[];
  klubCategory: TicketAvailableDataKlubCategory;
  categorySlug: string[];
  country: TicketAvailableDataCountry;
  tier: string;
  ticketType: string;
  isFixedDate: boolean;
  specialDiscount: any;
  packages: TicketAvailableDataPackage[];
  calendar: TicketAvailableDataCalendar[];
  itineraryDetail: TicketAvailableDataPackageItineraryDetail[];
}

export class GetTicketAvailableData {
  name: string;

  isJoin: boolean;

  isSEO: boolean;

  bestSeller: boolean;

  topRating: boolean;

  rounds: string[];

  klubCategory: TicketAvailableDataKlubCategory;

  categorySlug: string[];

  country: TicketAvailableDataCountry;

  tier: string;

  ticketType: string;

  isFixedDate: boolean;

  specialDiscount: any;

  packages: TicketAvailableDataPackage[];

  calendar: TicketAvailableDataCalendar[];

  itineraryDetail: TicketAvailableDataPackageItineraryDetail[];

  constructor(response: TicketAvailableData) {
    this.name = response.name ?? "";
    this.isJoin = !!response.isJoin;
    this.isSEO = !!response.isSEO;
    this.bestSeller = !!response.bestSeller;
    this.topRating = !!response.topRating;
    this.rounds = response.rounds ?? [];
    this.klubCategory = new GetTicketAvailableDataKlubCategory(
      response.klubCategory,
    );
    this.categorySlug = response.categorySlug ?? [];
    this.country = new GetTicketAvailableDataCountry(response.country);
    this.tier = response.tier ?? "";
    this.ticketType = response.ticketType ?? "";
    this.isFixedDate = !!response.isFixedDate;
    this.packages = (response.packages ?? []).map(
      (res) => new GetTicketAvailableDataPackage(res),
    );
    this.calendar = (response.calendar ?? []).map(
      (res) => new GetTicketAvailableDataCalendar(res),
    );
    this.itineraryDetail = (response.itineraryDetail ?? []).map(
      (res) => new GetTicketAvailableDataPackageItineraryDetail(res),
    );
  }
}

export interface ResponseGetTicketAvailableInterface {
  status: boolean;
  message: string;
  data: TicketAvailableData;
}

export class ResponseGetTicketAvailable {
  status: boolean;

  message: string;

  data: TicketAvailableData;

  constructor(response: ResponseGetTicketAvailableInterface) {
    this.status = response.status ?? false;
    this.message = response.message ?? "";
    this.data = new GetTicketAvailableData(response.data);
  }
}
